<template>
  <div class="partnerList">
    <div class="switchCon">
      <div @click="getlist('reset','brand')" :class="[flag ? 'activitySwitch switch' : 'switch']">品牌展示区</div>
      <div @click="getlist('reset','company')" :class="[flag ? 'switch' : 'activitySwitch switch']">生产企业展示区</div>
    </div>
    <div class="parterCon">
      <div class="left">
        <img v-if="(flag && switchParam.page1 == 1) || (!flag && switchParam.page2 == 1)" class="icon" src="../assets/leftPage1.png" alt="">
        <img v-else @click="getlist('subtract')" class="icon" src="../assets/leftPage2.png" alt="">
      </div>
      <el-row class="con" :gutter="28" v-loading="loading">
        <el-col :span="6" v-for="(item,index) in brand.items" :key="index">
          <div class="list" @click="goDetail(item)">
            <img :src="flag ? item.brand_pic : item.supplier_logo_img" @error="setDefaultImg" class="leftList" alt="">
            <div class="rightList">
              <div class="firstLine">{{ flag ? item.brand_name : item.supplier_name }}</div>
              <div v-if="flag" class="secondLine">{{ item.brand_english_name }}</div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="right">
        <img v-if="(flag && switchParam.page1 * 20 >= brand.total) || (!flag && switchParam.page2 * 20 >= brand.total) " class="icon" src="../assets/rightPage1.png" alt="">
        <img @click="getlist('add')" v-else class="icon" src="../assets/rightPage2.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'partnerList',
  data() {
    return{
      flag: true,
      switchParam: {
        page1: 1,
        page2: 1
      },
      brand: {total:0, items: []},
      imgHeight: '0px',
      loading: false
    }
  },
  mounted() {
    this.getlist('reset', 'brand');
  },
  methods: {
    goDetail(item) {
      if (this.flag) {
        this.$router.push({path: '/brandDetail', query: {brand_id: item.brand_id}})
      } else{
        this.$router.push({path: '/supplierDetail', query: {supplier_id: item.supplier_id}})
      }
    },
    setDefaultImg(event) {
      if (this.flag) {
        event.target.src = require("../assets/head2.png");
      } else {
        event.target.src = require("../assets/head1.png");
      }
    },
    getlist(page, type) {
      this.loading = true;
      if(page === 'reset') {
        if (type === 'brand') {
          this.switchParam.page1 = 1;
          this.flag = true;
        }else {
          this.switchParam.page2 = 1;
          this.flag = false;
        }
      }
      if(page === 'add') {
        if (this.flag) {
          this.switchParam.page1 ++;
        } else {
          this.switchParam.page2 ++;
        }
      }
      if(page === 'subtract') {
        if (this.flag) {
          this.switchParam.page1 --;
        } else {
          this.switchParam.page2 --;
        }
      }
      $.ajax({
        type: "get",
        url: this.flag ? "/officialapi/brand/list" : "/officialapi/supplier/list",
        async: true,
        data: {
          "page": this.flag ? this.switchParam.page1 : this.switchParam.page2,
          "page_size": 20
        },
        success: (data) => {
          this.loading = false;
          if (data["code"] == 0) {
            this.brand = data.data;
          } else {
            this.$message.error(data.msg);
          }
        }
      })

    },
  }
}
</script>

<style lang="less" scoped>
.partnerList{
  .switchCon{
    border-radius: 6px;
    opacity: 1;
    background: #FFFFFF;
    box-sizing: border-box;
    border: 1px solid #4A90E2;
    display: inline-block;
    margin-bottom: 35px;
    height: 50px;
    .switch{
      cursor: pointer;
      display: inline-block;
      width: 180px;
      height: 50px;
      line-height: 50px;
      font-family: Source Han Sans;
      font-size: 16px;
      font-weight: normal;
      font-variation-settings: "opsz" auto;
      color: #666666;
    }
    .activitySwitch{
      color: #fff;
      background-image: url("../assets/select.png");
      background-size:100% 59px;
      height: 59px;
    }
  }
  .parterCon{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1200px;
    margin: 0 auto;
    .left{
      .icon{
        width: 50px;
        height: 50px;
        margin-right: 28px;
        cursor: pointer;
      }
    }
    .con{
      width: 1044px;
      height: 510px;
      .list{
        border-radius: 6px;
        background: #EBEBEB;
        height: 76px;
        margin-bottom: 26px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 0 21px;
        cursor: pointer;
        white-space: pre-wrap;
        word-break: break-word;
        .leftList{
          width: 56px;
          height: 56px;
          border-radius: 50%;
          margin-right: 19px;
        }
        .rightList{
          text-align: left;
          .firstLine{
            font-family: Source Han Sans;
            font-size: 20px;
            font-weight: bold;
            line-height: 22px;
            letter-spacing: 0px;
            font-variation-settings: "opsz" auto;
            color: #222222;
            margin-bottom: 4px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 120px;
          }
          .secondLine{
            font-family: Source Han Sans;
            font-size: 16px;
            font-weight: normal;
            line-height: 22px;
            letter-spacing: 0px;
            font-variation-settings: "opsz" auto;
            color: #666666;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 120px;
          }
        }
      }
    }
    .right{
      .icon{
        width: 50px;
        height: 50px;
        margin-left: 28px;
        cursor: pointer;
      }
    }
  }
}
</style>